export enum EventTypeEnum {
    TenantChanged = "TENANT_CHANGED",
    SignedIn = "SIGNED_IN",
    QuickLoginRequested = "QUICK_LOGIN_REQUESTED",
    BigScroll = "BIG_SCROLL",
}